<template>
    <div 
        v-if="visible" 
        class="document-context-menu"
        :style="{ top: position.y + 'px', left: position.x + 'px' }"
        @click.stop
        ref="menu"
    >
        <div class="context-menu-item" @click="handleAction('edit')" v-if="canEdit">
            <i class="fa fa-pencil"></i>
            <span>{{ $t('edit') }}</span>
        </div>
        
        <div class="context-menu-item" @click="handleAction('generate')" v-if="canGenerate">
            <i class="fa fa-magic"></i>
            <span>{{ $t('generate') }}</span>
        </div>
        
        <div class="context-menu-divider"></div>
        
        <div class="context-menu-item danger" @click="handleAction('delete')" v-if="canDelete">
            <i class="fa fa-trash"></i>
            <span>{{ $t('delete') }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DocumentContextMenu',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        position: {
            type: Object,
            default: () => ({ x: 0, y: 0 })
        },
        document: {
            type: Object,
            required: true
        }
    },
    computed: {
        canEdit() {
            return true;
        },
        canGenerate() {
            return true;
        },
        canDelete() {
            return this.$can('delete protokol-media');
        }
    },
    methods: {
        handleAction(action) {
            this.$emit('action', action);
        }
    },
    mounted() {
        // Adjust menu position if it goes off-screen
        this.$nextTick(() => {
            if (this.$refs.menu) {
                const menu = this.$refs.menu;
                const rect = menu.getBoundingClientRect();
                const viewportWidth = window.innerWidth;
                const viewportHeight = window.innerHeight;
                
                let newX = this.position.x;
                let newY = this.position.y;
                
                if (rect.right > viewportWidth) {
                    newX = viewportWidth - rect.width - 10;
                }
                
                if (rect.bottom > viewportHeight) {
                    newY = viewportHeight - rect.height - 10;
                }
                
                if (newX !== this.position.x || newY !== this.position.y) {
                    this.$emit('update:position', { x: newX, y: newY });
                }
            }
        });
    }
}
</script>

<style scoped>
.document-context-menu {
    position: fixed;
    background: var(--form-bg);
    border: 1px solid var(--border-default);
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    z-index: 10000;
    min-width: 180px;
    padding: 4px 0;
    color: var(--text-primary);
}

.context-menu-item {
    padding: 10px 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 14px;
    transition: background-color 0.2s ease;
    position: relative;
}

.context-menu-item:hover {
    background-color: var(--bg-card);
}

.context-menu-item.danger {
    color: #ef4444;
}

.context-menu-item.danger:hover {
    background-color: rgba(239, 68, 68, 0.1);
}

.context-menu-item i {
    width: 16px;
    text-align: center;
    font-size: 14px;
}

.context-menu-divider {
    height: 1px;
    background-color: var(--border-default);
    margin: 4px 0;
}
</style>
